import ForgotPasswordPage from './containers/ForgotPasswordPageContainer'

export default ForgotPasswordPage
